import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {ProductoPlazoInversion} from '../_models/producto-plazo-inversion';

@Injectable({
  providedIn: 'root'
})
export class ProductoPlazoInversionService {
  private rutServicio: string = AppSettings.rutServiciosAPL + "/api/productosPlazosInversion";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getAll(): Observable<ProductoPlazoInversion[]> {
    return this.httpClient.get<ProductoPlazoInversion[]>(this.rutServicio);
  }

  getEnabled(): Observable<ProductoPlazoInversion[]> {
    return this.httpClient.get<ProductoPlazoInversion[]>(`${this.rutServicio}/enabled}`);
  }

  getById(id: string): Observable<ProductoPlazoInversion[]> {
    return this.httpClient.get<ProductoPlazoInversion[]>(`${this.rutServicio}/${id}`);
  }

  getByIdProducto(id: string): Observable<ProductoPlazoInversion[]> {
    return this.httpClient.get<ProductoPlazoInversion[]>(`${this.rutServicio}/producto/${id}`);
  }

  getEnabledByIdProducto(id: string): Observable<ProductoPlazoInversion[]> {
    return this.httpClient.get<ProductoPlazoInversion[]>(`${this.rutServicio}/producto/${id}/enabled`);
  }

  create(registro: ProductoPlazoInversion): Observable<ProductoPlazoInversion> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoPlazoInversion>(this.rutServicio, registro);
  }

  update(registro: ProductoPlazoInversion): Observable<ProductoPlazoInversion> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoPlazoInversion>(this.rutServicio, registro);
  }

  bulk(registros: ProductoPlazoInversion[]): Observable<ProductoPlazoInversion[]> {
    registros.forEach((e: ProductoPlazoInversion) => e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoPlazoInversion[]>(`${this.rutServicio}/bulk`, registros);
  }
}
